import AccountSummary from 'app/components/AccordionCustom/AccountSummary/AccountSummary';

export default AccountSummary;
